export const validateNIF = (nif: string): boolean => {
    if (!['1', '2', '3', '5', '6', '8'].includes(nif.substring(0, 1)) && !['45', '70', '71', '72', '77', '79', '90', '91', '98', '99'].includes(nif.substring(0, 2))) {
        return false;
    }
    const total = Number(nif[0]) * 9 + Number(nif[1]) * 8 + Number(nif[2]) * 7 + Number(nif[3]) * 6
        + Number(nif[4]) * 5 + Number(nif[5]) * 4 + Number(nif[6]) * 3 + Number(nif[7]) * 2;
    const modulo11 = total - Math.trunc(total / 11) * 11;
    const comparador = modulo11 === 1 || modulo11 === 0 ? 0 : 11 - modulo11;

    return Number(nif[8]) === comparador;
};
